import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import AthleteAvatar from '../AthleteAvatar';

export const AthletePerformanceRail = ({ participants, athletesById, selectedId, onSelect }) => (
  <Card className="lg:sticky lg:top-4 self-start" data-testid="athlete-rail">
    <CardHeader className="pb-2"><CardTitle className="text-sm">Participants ({participants.length})</CardTitle></CardHeader>
    <CardContent className="space-y-1 max-h-[70vh] overflow-y-auto">
      {participants.length === 0 && <p className="text-sm text-gray-500 py-4 text-center" data-testid="mp-no-participants">No participants.</p>}
      {participants.map(p => {
        const a = athletesById[p.athlete_id] || {};
        const on = p.athlete_id === selectedId;
        return (
          <button key={p.id} onClick={() => onSelect(p.athlete_id)}
            className={`w-full flex items-center gap-2 p-2 rounded-lg text-left transition-colors ${on
              ? 'bg-emerald-50 ring-1 ring-emerald-200' : 'hover:bg-gray-50'}`}
            data-testid={`athlete-select-${p.athlete_id}`}>
            <AthleteAvatar photoUrl={a.profile_photo} thumbUrl={a.profile_photo_thumbnail}
                           name={p.athlete_name || a.full_name} size="sm" />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate">{p.athlete_name || a.full_name || p.athlete_id}</p>
              <p className="text-xs text-gray-500 truncate">
                {p.position || '—'}{p.minutes_played != null ? ` · ${p.minutes_played}'` : ''}
                {p.rating != null ? ` · ${p.rating}` : ''}
              </p>
            </div>
          </button>
        );
      })}
    </CardContent>
  </Card>
);

export default AthletePerformanceRail;
